// extracted by mini-css-extract-plugin
export default {"container":"style_container__PUczp","border_b":"style_border_b__RqSRR"};